import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./NotFound.css";

export default function NotFound() {
  const bgStyle = {
    backgroundImage: "url('/404-illustration_new.png')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  };

  return (
    <div className="not-found-page" style={bgStyle}>
      <Helmet>
        <title>404 — Page Not Found | Nova SEO</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-subtitle">Page Not Found</p>
        
        <p className="not-found-text">
          Oops! It seems you've drifted off course.<br />
          The page you are looking for is exploring another dimension.
        </p>
        
        <div className="not-found-actions">
          <Link to="/" className="cta-primary">
            Back to Dashboard
          </Link>
          <Link to="/audit" className="cta-secondary">
            Explore Solutions
          </Link>
        </div>
      </div>
    </div>
  );
}
